import { createContext } from "react";

// set the defaults
const ProductContext = createContext({ product: null });

export default ProductContext;